/**
 * Footer Data — Macluumaadka Footer-ka
 *
 * Halkan ka badal links-ka, social media-da, iyo xiriirka
 */

/* Links-ka Alaabta (Product) */
export const productLinks = [
  { label: "Adeegyada", href: "#features" },
  { label: "Lacag bixinta", href: "#payments" },
  { label: "App Mobile-ka", href: "#" },
];

/* Links-ka Shirkadda (Company) */
export const companyLinks = [];

/* WhatsApp number — halkan ka badal */
export const WHATSAPP_NUMBER = "+252619150114";
export const WHATSAPP_URL = `https://wa.me/252619150114`;
export const PHONE_DISPLAY = "+252 619 150 114";
